<template>
  <router-view />
  <Toast />

  <div v-if="isAdmin" class="admin-btn-block">
    <div class="navigation">
      <router-link to="/">Главная</router-link>
      <router-link to="/admin">Админ-панель</router-link>
      <router-link to="/artifacts">Артефакты</router-link>
      <router-link to="/tracked-artefacts">Отслеживание</router-link>
      <router-link to="/module">История модулей</router-link>
      <router-link to="/module-stat">Анализ модулей</router-link>
    </div>
    <div>
      <div class="admin-info">
        Администратор: {{ authStore?.user?.username }}
        <button @click="handleLogout" class="admin-btn">Выйти</button>
        <div>
          <button @click="subscribeToPush">Рассылка</button>
        </div>
      </div>

      <div v-for="i in adminsOnline" :key="i">{{ i }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, computed } from 'vue'
import { useWebSocketStore } from '@/store/websocket.store'
import { useAuthStore } from '@/store/auth'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import { api } from '@/api'

const wsStore = useWebSocketStore()
const authStore = useAuthStore()
const router = useRouter()

const isAdmin = computed(() => authStore.isAdmin)
const adminsOnline = computed(() => wsStore.adminsOnline)

// const initWebSocket = () => {
//   if (isAdmin.value && !wsStore.isConnected) {
//     wsStore.connect();
//
//     // wsStore.subscribe("auction_data", (data) => {
//     //   console.log("🔄 Auction update:", data);
//     // });
//
//     // wsStore.subscribe("price_stats", (data) => {
//     //   console.log("📊 Price stats received:", data);
//     // });
//   }
// };

// watch(
//   isAdmin,
//   (newVal) => {
//     if (newVal) {
//       initWebSocket();
//     } else {
//       wsStore.disconnect();
//     }
//   },
//   { immediate: true }
// );

const cleanupWebSocket = () => {
  wsStore.listeners.clear()
  wsStore.disconnect()
}

onBeforeUnmount(() => {
  cleanupWebSocket()
})

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
  cleanupWebSocket()
}

onMounted(() => {
  authStore.init()
})

async function subscribeToPush() {
  const permission = await Notification.requestPermission()

  if (permission !== 'granted') {
    alert('Разрешите уведомления для подписки')
    return
  }

  const register = await navigator.serviceWorker.register('/sw.js')
  const publicKey =
    'BJ94Ds_fnz53GbYp3iCcShyg9U6sOoxxgF6GivAaLZtGwubwlVrD8C57AoFeKej1bOvoYinD4W0r9by1_Wn4sNc'

  const subscription = await register.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  })

  await api.post('/push/subscribe', subscription)

  alert('Подписка оформлена')
}

// utils
function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
}
</script>

<style lang="scss">
:root {
  color-scheme: dark;
}

body {
  background-color: #1e1e1e;
  color: #f0e6d2;
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
}

.auction-table {
  width: 80%;
  margin: 20px auto;
  background-color: #2c2c2c;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.admin-btn {
  background: #3b82f6;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  margin: 10px 20px;
}

.admin-btn:hover {
  background: #2563eb;
}

.admin-info {
  background: #f0fdf4;
  color: #1e1e1e;
  padding: 10px;
  border-left: 4px solid #10b981;
  margin-bottom: 10px;
}

.admin-btn-block {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.navigation {
  border-radius: 10px;
  padding: 10px;
  display: flex;
  background-color: #f0fdf4;
  align-items: center;
  gap: 20px;
  color: #1e1e1e;

  a {
    all: unset;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      cursor: pointer;
      color: orange;
    }
  }

  .router-link-active {
    color: orange;
  }
}

#webpack-dev-server-client-overlay {
  display: none !important;
}
</style>
